module.exports = __webpack_public_path__ + "img/icon_nationality.e21d06cc.svg";